import React, { useState, useRef, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/shared image.png";
import IndiaFlag from "../assets/artwork.png";
import SecurityImg from "../assets/security.svg.png"
import SupportImg from "../assets/support.svg.png"
import PolicyImg from '../assets/policy.svg.png'
import VerifedVenderImg from '../assets/3d-render-man-relax-practice-yoga-meditation 1.png'
import { IoEllipsisHorizontal } from "react-icons/io5";  // Import three-dot icon
import usericon from "../assets/user-icon.svg";
import personImg from "../assets/toursImages/profile nav bar icon (1).svg";



const Navbar = ({ isLoggedIn, setIsLoggedIn }) => {
  const navigate = useNavigate(); 
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [emailOrMobile, setEmailOrMobile] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otp, setOtp] = useState(new Array(4).fill("")); // Array to store OTP digits
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [requestId, setRequestId] = useState(""); // Add state to hold the requestId
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("English"); // Default language
  
  
  useEffect(() => {
    const storedLoginStatus = localStorage.getItem("isLoggedIn");
    if (storedLoginStatus === "true") {
      setIsLoggedIn(true);
    }
  }, []);
  

 
  const handleClose = () => {
    setShow(false);
    window.location.reload(); // Reload the page when the modal is closed
  };
  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem("isLoggedIn"); // ✅ clear storage
    setShowOptions(false); 
    setOtp(new Array(4).fill("")); 
    setEmailOrMobile(""); 
    navigate("/"); 
    window.location.reload(); 
  };
  
  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };


  // user authetnication
 
  const handleContinueClick = async () => {
    // Clean input to keep only digits
    const cleanedNumber = emailOrMobile.replace(/\D/g, '');
  
    // Check if it's a valid 10-digit mobile number
    const isValid10Digit = /^\d{10}$/.test(cleanedNumber);
  
    if (isValid10Digit) {
      const fullNumber = `+91${cleanedNumber}`;
      setErrorMessage("");
  
      const payload = {
        phoneNumber: fullNumber,
        expiry: 30,
        otpLength: 4,
        channels: ["SMS"],
      };
  
      try {
        const response = await fetch('https://auth.otpless.app/auth/v1/initiate/otp', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'clientId': 'T34T9PJISXCOUKI5K7MOEIQ2OBH6I5LM',
            'clientSecret': 'jjnj1elu44tzddslqv95qy4ze8j7y82x',
          },
          body: JSON.stringify(payload),
        });
  
        if (response.ok) {
          const data = await response.json();
          console.log("OTP sent successfully", data);
          setRequestId(data.requestId);
          setIsOtpSent(true);
          setEmailOrMobile(""); // Clear input after successful OTP request
        } else {
          const errorData = await response.json();
          console.error("OTP Error:", errorData);
          setErrorMessage("Failed to send OTP. Please try again.");
        }
      } catch (error) {
        console.error("Request error:", error);
        setErrorMessage("An error occurred while sending the OTP. Please try again.");
      }
    } else {
      setErrorMessage("Please enter a valid 10-digit mobile number.");
    }
  };
  
  const handleOtpChange = (element, index) => {
    const value = element.value;
    if (isNaN(value)) return; // Prevent non-numeric input
    const otpCopy = [...otp];
    otpCopy[index] = value; // Update the current index
    setOtp(otpCopy);

    // Focus the next input box automatically
    if (element.nextSibling && value) {
      element.nextSibling.focus();
    }
  };
  const handleVerifyOtp = async () => {
    // Join the OTP array into a single string
    const enteredOtp = otp.join("");

    // Check if OTP is empty
    if (!enteredOtp) {
        setErrorMessage("Please enter the OTP before proceeding.");
        return; // Stop further execution
    }
    
    // Prepare the data to send
    const payload = {
        requestId: requestId, // Use the stored requestId
        otp: enteredOtp, // Use the entered OTP
    };

    try {
        // Sending the POST request to the verification endpoint
        const response = await fetch('https://auth.otpless.app/auth/v1/verify/otp', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json', 
                'clientId': 'T34T9PJISXCOUKI5K7MOEIQ2OBH6I5LM', 
                'clientSecret': 'jjnj1elu44tzddslqv95qy4ze8j7y82x', 
            },
            body: JSON.stringify(payload), 
        });

        // Check the response status
        if (response.ok) {
          const data = await response.json();
          console.log("OTP verified successfully", data);
        
          localStorage.setItem("isLoggedIn", "true");  // ✅ store status
          setIsLoggedIn(true); // Set user as logged in
          setShow(false); // Close the modal
          setErrorMessage("");
        }
        else {
          const errorData = await response.json();
          setErrorMessage("Invalid OTP. Please try again.");
      }
  } catch (error) {
      setErrorMessage("An error occurred while verifying the OTP. Please try again.");
  }
  };



  return (
    <>
      <nav className="navbar navbar-expand-lg bg-white"> 
        <div className="container-fluid d-flex justify-content-between align-items-center">
          
          
          {/* Logo */}
          <img
            src={logo}
            width={110}
            alt="logo"
            className="img-fluid"
            style={{ height: "43px", margin: "0", cursor: "pointer" }}
            onClick={() => navigate("/")}
          />


          {/* Navbar Items - Always Visible */}
          <div className="d-flex align-items-center gap-3">
            {/* Country Selector */}
            <div className="position-relative">
              <div className="d-flex align-items-center gap-2">
                <img src={IndiaFlag} alt="India Flag" width="20" height="14" />
                <select
                  className="border-0 bg-transparent fw-bold"
                  style={{
                    fontSize: "12px",
                    outline: "none",
                    appearance: "none", // Removes default dropdown styling
                    cursor: "not-allowed", // Disabled look
                    color: "#492B8B", // Same as button text color
                  }}
                  disabled // Dropdown is disabled for now
                >
                  <option value="IN">IN</option>
                  <option value="UAE">UAE</option>
                  
                </select>
              </div>
            </div>

            {/* Three-dot menu */}
            {isLoggedIn && (
              <div className="position-relative">
                <button
                  className="border-0 bg-transparent p-1"
                  style={{ cursor: "pointer" }}
                  onClick={toggleOptions}
                >
                  <IoEllipsisHorizontal size={20} color="#492B8B" />
                </button>

                {/* Options Modal */}
                {showOptions && (
                  <div
                    className="position-absolute bg-white shadow p-3 rounded"
                    style={{
                      top: "40px",
                      right: "0",
                      display: "flex",
                      alignItems: "center",
                      gap: "20px", // More space between items
                      border: "1px solid rgba(147, 111, 224, 1)",
                      zIndex: 1000,
                      width: "200px", // Bigger modal
                      padding: "10px",
                    }}
                  >
                    {/* Language Selector */}
                    <select
                      value={selectedLanguage}
                      onChange={(e) => setSelectedLanguage(e.target.value)}
                      className="border-0 bg-transparent fw-bold"
                      style={{ fontSize: "12px", color: "#492B8B", cursor: "pointer" }}
                    >
                      <option value="EN">English</option>
                      <option value="HI">Hindi</option>
                    </select>

                    {/* Logout Button - Same Style as Login */}
                    <button
                      className="fw-bold rounded-pill ps-2 pe-2 pt-1 pb-1"
                      style={{
                        fontSize: "12px",
                        border: "2px solid rgba(147, 111, 224, 1)",
                        color: "rgba(73, 43, 139, 1)",
                        backgroundColor: "white",
                        cursor: "pointer",
                      }}
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            )}

            {/* Login / Sign Up Button */}
            <button
              onClick={isLoggedIn ? () => navigate("/profile") : handleShow}
              className="fw-bold rounded-pill ps-2 pe-2 pt-1 pb-1 login-btn"
              style={{
                fontSize: "12px",
                border: "2px solid rgba(147, 111, 224, 1)",
                color: "rgba(73, 43, 139, 1)",
                transition: "background-color 0.3s ease",
                backgroundColor: "white",
                cursor: isLoggedIn ? "default" : "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#9365e0";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "white";
              }}
            >
                        <img src={personImg} alt="profile" width={30} height={25} />
              
              {isLoggedIn ? "Hi, User" : "Login / Sign Up"}
            </button>
          </div>


        </div>
      </nav>

     {/* Modal */}
      <div>
        {show && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ 
              backgroundColor: "rgba(0,0,0,0.4)", 
              zIndex: 1050, 
              backdropFilter: "blur(3px)" 
            }}
          >
            {/* Main Modal Container */}
            <div 
              className="container d-flex flex-column flex-md-row bg-light p-0 position-relative"
              style={{ 
                width: "90%",  // ✅ Prevents overflow on small screens
                maxWidth: "700px",  // ✅ Keeps modal manageable on larger screens
                height: "auto",  
                maxHeight: "90vh", // ✅ Prevents it from going off-screen
                overflowY: "auto", // ✅ Allows scrolling if needed
                borderRadius: "14px",
                boxShadow: "0 30px 35px rgba(0, 0, 0, 0.2)"
              }}
            >
              {/* Left Section */}
              <div 
                className="p-4 bg-white rounded-start w-50 d-flex flex-column align-items-center justify-content-center"
                style={{ minHeight: "100%", paddingTop: "30px" }} 
              >
                <h4 className="text-center fw-bold mt-3" style={{ fontSize: "clamp(16px, 2vw, 20px)" }}>
                  {isOtpSent ? "ENTER OTP" : "LOGIN OR SIGN UP"}
                </h4>
                <p className="small text-center mb-3">
                  {isOtpSent ? "Enter the OTP sent to Mobile." : "How to get started on your journey with us?"}
                </p>

                {/* Input and Button */}
                <div className="mt-3 text-center position-relative">
                  {!isOtpSent && (
                    <>
                      <div className="input-group mb-2 mx-auto" style={{ width: "80%" }}>
                        <span className="input-group-text bg-white" style={{ border: "1px solid rgba(84, 28, 156, 1)" }}>
                          +91
                        </span>
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Enter mobile number"
                          style={{ border: "1px solid rgba(84, 28, 156, 1)" }}
                          value={emailOrMobile}
                          onChange={(e) => {
                            // Remove any leading zeros and restrict to digits only
                            const cleaned = e.target.value.replace(/\D/g, '');
                            setEmailOrMobile(cleaned);
                            setErrorMessage("");
                          }}
                        />
                      </div>

                      {errorMessage && <div className="text-danger">{errorMessage}</div>}
                      <button
                        className="fw-bold text-white rounded-4 mt-3 border-0 ps-3 pt-1 pb-1 pe-3"
                        style={{ background: "rgba(84, 28, 156, 1)" }}
                        onClick={handleContinueClick}
                      >
                        Continue
                      </button>
                    </>
                  )}

                  {/* OTP Input Fields */}
                  {isOtpSent && (
                    <>
                      <div className="d-flex justify-content-center gap-1 gap-md-2 mt-4">
                        {otp.map((data, index) => (
                          <input
                            key={index}
                            type="text"
                            maxLength="1"
                            className="form-control text-center"
                            style={{ width: "40px", border: "1px solid rgba(84, 28, 156, 1)" }}
                            value={data}
                            onChange={(e) => handleOtpChange(e.target, index)}
                          />
                        ))}
                      </div>
                      <button
                        className="fw-bold rounded-4 mt-3 border-0 text-white ps-3 pt-1 pb-1 pe-3"
                        style={{ background: "rgba(84, 28, 156, 1)" }}
                        onClick={handleVerifyOtp}
                      >
                        Verify OTP
                      </button>
                    </>
                  )}
                </div>
              </div>


              {/* Right Section (Always Visible on All Screens) */}
              <div 
                className="p-3 text-white rounded-end d-flex flex-column align-items-center justify-content-center"
                style={{ 
                  flex: 1, 
                  minWidth: "50%", // ✅ Ensures it does not disappear
                  background: "linear-gradient(217.64deg, #9181F4 -5.84%, #5038ED 106.73%)",
                  overflow: "hidden",
                  padding: "20px"
                }}
              >
                <div className="border-white border-2 rounded-4 p-3 text-center" 
                  style={{ 
                    maxWidth: "80%", 
                    
                    background: "rgba(255, 255, 255, 0.25)" 
                  }}
                >
                  <h2 style={{ fontSize: "clamp(18px, 2vw, 26px)" }}>
                    Why Choose <span style={{ color: "rgba(139, 9, 219, 1)" }}>Vigovia?</span>
                  </h2>

                  {/* Feature List */}
                  <div className="d-flex flex-column gap-2 align-items-start">
                    <div className="d-flex align-items-center">
                      <img src={SecurityImg} alt="security" width="40" height="40" />
                      <span className="fw-bold ps-2">Safe And Secure Trip</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <img src={SupportImg} alt="support" width="40" height="40" />
                      <span className="fw-bold ps-2">24/7 Assistance</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <img src={PolicyImg} alt="policy" width="40" height="40" />
                      <span className="fw-bold ps-2">Easy Refund Policy</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <img src={VerifedVenderImg} alt="vendor" width="40" height="40" />
                      <span className="fw-bold ps-2">Verified Vendors</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Close Button */}
              <button
                type="button"
                className="btn-close position-absolute end-0 m-3"
                aria-label="Close"
                onClick={handleClose}
              ></button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Navbar;
